/* DIETMONSTA · touch equivalent of the card image hover-swap.
   Delegated globally (loaded once in theme.liquid) because dm-card-media
   renders inside several independent custom elements (dm-ready-meals,
   dm-custom-prep, dm-bulk-packs, dm-menu) that would otherwise each need
   their own copy of this handler.

   Touch devices have no :hover, so the cross-fade in dm-tokens.css never
   triggers there. On those devices only, tapping the image itself toggles
   it instead. Hover-capable devices are left alone entirely — a click
   there keeps its normal effect (nothing on the builder cards, navigation
   on the homepage's linked cards), same as before this existed. */
const isTouch = window.matchMedia('(hover: none)').matches;

if (isTouch) {
  document.addEventListener('click', (event) => {
    const media = event.target.closest('.dm-b__media, .dm-mealcard__media');
    if (!media || !media.querySelector('.dm-card-img--alt')) return;

    // The media sits inside a card that's a button (add-to-plate) or a
    // link (navigate to product) — stop both so the tap only flips the
    // photo, matching what desktop hover does without leaving the card.
    event.preventDefault();
    event.stopPropagation();

    media.classList.toggle('is-swapped');
  });
}
